async function getContact() {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/contact?populate=*`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getContact;
